var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6839_48710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6839_48710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.86523 20.5L11.9997 2.99997L22.1342 20.5H1.86523ZM4.44973 19H19.5497L11.9997 5.99997L4.44973 19ZM11.9997 17.8077C12.2286 17.8077 12.4204 17.7303 12.5752 17.5755C12.7301 17.4206 12.8075 17.2288 12.8075 17C12.8075 16.7711 12.7301 16.5793 12.5752 16.4245C12.4204 16.2696 12.2286 16.1922 11.9997 16.1922C11.7709 16.1922 11.5791 16.2696 11.4242 16.4245C11.2694 16.5793 11.192 16.7711 11.192 17C11.192 17.2288 11.2694 17.4206 11.4242 17.5755C11.5791 17.7303 11.7709 17.8077 11.9997 17.8077ZM11.2497 15.1922H12.7497V10.1922H11.2497V15.1922Z",
    fill: "#EB5757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.812f111516f7d588ecd0215f5c3a04cf.svg";
export { ForwardRef as ReactComponent };